import { lt } from '@mews/framework';
import { Button, DropdownItem, SplitButton } from '@optimus-web/core';
import { matchAndMergeTestIds } from '../../../../../constants';
import { MergeMode } from '../../../../../types';

interface ReviewOptionsProps {
    disabled: boolean;
    mergeMode: MergeMode;
    onKeepSeparate: () => void;
    onReviewLater: () => void;
}

export const ReviewOptions = ({ disabled, mergeMode, onKeepSeparate, onReviewLater }: ReviewOptionsProps) => {
    if (mergeMode === MergeMode.Queue) {
        return (
            <SplitButton
                data-test-id={matchAndMergeTestIds.keepSeparatedButton}
                disabled={disabled}
                label={lt('AccountMergeKeepSeparate')}
                variant="secondary"
                type="button"
                onClick={onKeepSeparate}
            >
                <DropdownItem
                    data-test-id={matchAndMergeTestIds.reviewLaterButton}
                    label={lt('AccountMergeReviewLater')}
                    onClick={onReviewLater}
                />
            </SplitButton>
        );
    }
    return (
        <Button
            variant="secondary"
            type="button"
            data-test-id={matchAndMergeTestIds.reviewLaterButton}
            onClick={onReviewLater}
        >
            {lt('AccountMergeReviewLater')}
        </Button>
    );
};
